module.exports = __webpack_public_path__ + "img/hsrx.6d74b037.png";